import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  ITransferPricingDocumentationVersionPreviewResponse,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not open this version. Please try again.';

export const getTransferPricingDocumentationVersionPreviewUrl = (
  documentationId: string,
  versionId: string,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<ITransferPricingDocumentationVersionPreviewResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: TransferPricingDocumentationRequestHelper.versionPreviewPath(
      documentationId,
      versionId
    ),
    method: 'GET',
    isExpectedBody:
      TransferPricingDocumentationRequestHelper.isVersionPreviewResponse,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
